export const MAINTENANCE_STATUS_REQUEST = "MAINTENANCE_STATUS_REQUEST";
export const MAINTENANCE_STATUS_SUCCESS = "MAINTENANCE_STATUS_SUCCESS";
export const MAINTENANCE_STATUS_FAIL = "MAINTENANCE_STATUS_FAIL";
